module.exports = __webpack_public_path__ + "2c694181e37ab347dfa0b0d3729bea4d.MP3";